module.exports = __webpack_public_path__ + "img/product-placeholder-44.e2ecd35.png";